import { useIntl } from 'react-intl'

export function useHighlightMessages() {
  const intl = useIntl()

  const highlightMessageAvailableForDates = intl.formatMessage({
    id: 'ojRHOgxIYT',
    defaultMessage: 'We found a limited time deal for your hotel. Choose dates and book now before it ends!',
    description: 'Highlight banner message when a limited time deal is available for selected dates',
  })

  const highlightMessageStayMinNights = (minNumNights: number) => intl.formatMessage(
    {
      id: 'lPbRpiYz+n',
      defaultMessage: 'Stay for at least {minNumNights, plural, one {# night} other {# nights}} to enjoy this special offer',
      description: 'Highlight banner message indicating minimum nights required for a special offer',
    },
    { minNumNights },
  )

  const unavailableBannerMessageStayMinNights = (minNumNights: number) => intl.formatMessage(
    {
      id: 'FRjZTVd0n4',
      defaultMessage: 'Stay for at least {minNumNights, plural, one {# night} other {# nights}} to unlock this offer',
      description: 'Unavailability banner message indicating minimum nights required to unlock an offer',
    },
    { minNumNights },
  )

  const highlightMessageUnavailableForDates = (saleUnit: string) => {
    const unit = saleUnit.toLowerCase()
    switch (unit) {
      case 'room':
        return intl.formatMessage({
          id: 'e9KFX52TiG',
          defaultMessage: 'There are no rooms available for your selected dates.',
          description: 'Highlight banner message when no rooms are available for selected dates',
        })
      case 'night':
        return intl.formatMessage({
          id: 'UD4398gbzf',
          defaultMessage: 'There are no nights available for your selected dates.',
          description: 'Highlight banner message when no nights are available for selected dates',
        })
      case 'package':
        return intl.formatMessage({
          id: 'KbG/ezczJU',
          defaultMessage: 'There are no packages available for your selected dates.',
          description: 'Highlight banner message when no packages are available for selected dates',
        })
      default:
        return intl.formatMessage(
          {
            id: 'T6iCX4YTOW',
            defaultMessage: 'There are no {unit} available for your selected dates.',
            description: 'Highlight banner message when no availability for selected dates, with dynamic unit type',
          },
          { unit },
        )
    }
  }

  return {
    highlightMessageAvailableForDates,
    highlightMessageStayMinNights,
    unavailableBannerMessageStayMinNights,
    highlightMessageUnavailableForDates,
  }
}
